import React from "react";
import home1 from "../img/home1.png";
//Framer Motion
import { motion } from "framer-motion";
import { titleAnim, fade, photoAnim } from "../animation";

import { About, Description, Image, Hide } from "../styles";
import Wave from "./Wave";

const AboutSection = () => {
  return (
    <About>
      <Description>
        <div className="title">
          <Hide>
            <motion.h2 variants={titleAnim}>We work to make</motion.h2>
          </Hide>

          <Hide>
            <motion.h2 variants={titleAnim}>
              your <span>dreams</span> come
            </motion.h2>
          </Hide>

          <Hide>
            <motion.h2 variants={titleAnim}>true.</motion.h2>
          </Hide>
        </div>

        <motion.p variants={fade}>
          Contact us for any photography or videography ideas you have. Our
          exceptionally talented professionals will handle the rest.
        </motion.p>

        <motion.button variants={fade}>Contact Us</motion.button>
      </Description>

      <Image>
        <motion.img variants={photoAnim} src={home1} alt="Guy with a camera" />
      </Image>
      <Wave />
    </About>
  );
};

export default AboutSection;
